<template>
	<app-content class="h-panel">
		<Tabs :datas="tabDatas" v-model="selected" @change="change"></Tabs>
		<div class="padding-right-left padding-top">
			<span class="dark4-color">*提示：按 Ctrl + F 键并输入科目编码或者科目名称可以查找科目。</span>
			<div class="pull-right">
				<Button @click="create()" v-if="currentAccountSets.accountingStandards !== 0" color="primary">新增科目</Button>
				<Button @click="goInitImportWizard" color="primary">去一键初始化导入</Button>
				<Button @click="encodingSetting">编码设置</Button>
				<Button @click="repairLevels" color="warning">修复科目层级</Button>
				<Button @click="exportSubjects" color="primary">导出科目</Button>
				<Button @click="downloadTemplate" color="green">下载模板</Button>
				<Checkbox v-model="overwriteExistingOnImport">覆盖已有科目</Checkbox>
				<Button :loading="loading" @click="doUpload">
					<input ref="file" type="file" accept=".xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" style="display: none" @change="fileChange($event)">
					导入
				</Button>
			</div>
		</div>
		<div class="h-panel-body padding">
			<Table :datas="datas" border :loading="loading">
				<TableItem title="科目编码">
					<template slot-scope="{data}">
						<span :style="{paddingLeft:(data.level-1)*15+'px'}">{{data.code}}</span>
					</template>
				</TableItem>
				<TableItem title="科目名称" prop="name"></TableItem>
				<TableItem title="助记码" prop="mnemonicCode"></TableItem>
				<TableItem title="余额方向" prop="balanceDirection" align="center" :width="100"></TableItem>
				<TableItem title="数量核算" v-if="showUnit" prop="unit" align="center" :width="100"></TableItem>
				<TableItem title="辅助核算" v-if="showAssistAccounting">
					<template slot-scope="{data:{auxiliaryAccounting}}">
						{{auxiliaryAccounting?JSON.parse(auxiliaryAccounting).map(val=>val.name).join(','):''}}
					</template>
				</TableItem>
				<TableItem title="外币核算" v-if="showCurrencyAccounting">
					<template slot-scope="{data:{currencyAccounting}}">
						{{formatCurrencyAccounting(currencyAccounting)}}
					</template>
				</TableItem>
				<TableItem title="期末调汇" v-if="showPeriodEndRevaluation" align="center" :width="100">
					<template slot-scope="{data}">
						{{data.periodEndRevaluation ? '是' : '否'}}
					</template>
				</TableItem>
				<TableItem title="状态" align="center" :width="100">
					<template slot-scope="{data}">
						{{data.status?"正常":"不可用"}}
					</template>
				</TableItem>
				<TableItem title="操作" :width="150" align="center">
					<div class="actions" slot-scope="{data}">
						<span @click="create(data)" v-if="canCreateChild(data)">新增</span>
						<span v-if="!data.isLeaf" @click="edit(data)">编辑</span>
						<span v-if="!data.systemDefault" @click="remove(data)">删除</span>
					</div>
				</TableItem>
			</Table>
		</div>
		<Modal v-model="showForm" type="drawer-right" hasCloseIcon>
			<div slot="header">新增科目</div>
			<Form :readonly="used" ref="form" v-width="800" mode="twocolumn" :labelWidth="150" :model="form" :rules="validationRules">
				<img v-if="used" class="used" src="@/assets/used.png" alt="已使用">
				<FormItem label="科目编码" prop="code">
					<div class="h-input-group" v-if="!form.id && parent">
						<span class="h-input-addon bg-white-color" style="padding-right: 0;border-right: none;line-height: 32px;;color: #001529;">{{parent.code}}</span>
						<input style="padding-left: 0;border-left: none;" type="text" v-model="form.code" :maxlength="len">
					</div>
					<input v-else-if="!form.id && !parent" type="text" v-model="form.code" :maxlength="len">
					<input v-else type="text" v-model="form.code" disabled>
				</FormItem>
				<FormItem label="科目名称" prop="name">
					<input type="text" v-model="form.name" :disabled="form.systemDefault || used">
				</FormItem>
				<FormItem label="上级科目">
					<input type="text" :value="parentSubject" disabled>
				</FormItem>
				<FormItem label="余额方向">
					<Radio v-model="form.balanceDirection" :datas="['借','贷']" :disabled="parent"/>
				</FormItem>
				<FormItem label="状态">
					<Radio v-model="form.status" dict="statusRadios" :disabled="used"></Radio>
				</FormItem>
				<FormItem single label="">
					<Row type="flex" :space-x="10">
						<Cell>
							<Checkbox v-model="numberAccounting" :disabled="used">数量核算</Checkbox>
						</Cell>
						<template v-if="numberAccounting">
							<Cell class="label">计量单位</Cell>
							<Cell><input type="text" v-width="100" v-model="unit" :disabled="used"></Cell>
						</template>
					</Row>
				</FormItem>
				<FormItem single label="">
					<Row type="flex" :space-x="10">
						<Cell>
							<Checkbox v-model="assistAccounting" :disabled="used">辅助核算</Checkbox>
						</Cell>
						<template v-if="assistAccounting">
							<Cell>
								<Checkbox v-model="auxiliaryAccounting" :datas="accountingCategory" keyName="id" titleName="name" :disabled="used"></Checkbox>
							</Cell>
						</template>
					</Row>
				</FormItem>
				<FormItem single label="">
					<Row type="flex" :space-x="10">
						<Cell>
							<Checkbox v-model="enableCurrencyAccounting" :disabled="used">外币核算</Checkbox>
						</Cell>
						<template v-if="enableCurrencyAccounting">
						<Cell>
							<Checkbox v-model="currencyAccounting" :datas="currencyOptions" keyName="code" titleName="displayName" :disabled="used"></Checkbox>
						</Cell>
						<Cell>
							<Checkbox v-model="form.periodEndRevaluation" :disabled="used">期末调汇</Checkbox>
						</Cell>
					</template>
				</Row>
				</FormItem>
			</Form>
			<div class="text-center">
				<Button color="green" @click="submit" :disabled="used" :loading="loading">{{form.id?'保存':'保存'}}</Button>
				<Button @click="showForm=false">取消</Button>
			</div>
		</Modal>
		<Modal v-model="encodingSettingForm">
			<div slot="header">科目编码设置</div>
			<div class="padding">
				<div v-for="(len, index) in codeLen" :key="index" class="encoding-setting-item">
					<span class="encoding-setting-label">第{{index + 1}}级</span>
					<span v-if="index === 0" class="encoding-fixed">4</span>
					<Select v-else v-model="codeLen[index]" style="display: inline-block; width: 120px;" :datas="segmentLenOptions" :deletable="false"/>
				</div>
				<div class="encoding-setting-actions">
					<Button size="s" @click="addEncodingLevel" :disabled="codeLen.length >= maxSubjectLevel">新增一级</Button>
					<Button size="s" @click="removeEncodingLevel" :disabled="codeLen.length <= 1">删除末级</Button>
					<span class="dark2-color">当前编码：{{encodingPreview}}，最多支持 {{maxSubjectLevel}} 级</span>
				</div>
			</div>
			<div class="text-center">
				<Button color="green" @click="saveEncoding" :loading="loading">保存</Button>
				<Button @click="encodingSettingForm=false" :loading="loading">取消</Button>
			</div>
		</Modal>
		<Modal v-model="showImportMappingModal">
			<div slot="header">导入列映射确认</div>
			<div class="padding">
				<div class="margin-bottom">
					<div>检测到表头存在歧义，请确认系统字段与导入列的对应关系。</div>
					<div v-if="importPreview.missingRequired && importPreview.missingRequired.length" class="red-color">
						缺少必填字段映射：{{importPreview.missingRequired.join('、')}}
					</div>
				</div>
				<Table :datas="importMappingRows" border>
					<TableItem title="系统字段" :width="120">
						<template slot-scope="{data}">
							<span>{{data.expected}}<span v-if="data.required" class="red-color">*</span></span>
						</template>
					</TableItem>
					<TableItem title="导入列">
						<template slot-scope="{data}">
							<Select v-model="data.actual" :datas="importHeaderOptions" :deletable="false"></Select>
						</template>
					</TableItem>
					<TableItem title="建议" :width="220">
						<template slot-scope="{data}">
							<span>{{data.reason || '-'}}</span>
						</template>
					</TableItem>
					<TableItem title="置信度" :width="80" align="center">
						<template slot-scope="{data}">
							<span>{{formatConfidence(data.confidence)}}</span>
						</template>
					</TableItem>
				</Table>
			</div>
			<div class="text-center">
				<Button color="green" @click="confirmImportMapping" :loading="loading">确认导入</Button>
				<Button @click="cancelImportMapping" :loading="loading">取消</Button>
			</div>
		</Modal>
	</app-content>
</template>

<script>

	import Pinyin from 'chinese-to-pinyin'
	import StringUtils from 'string-utilz'
	import {mapState} from 'vuex';
	import {
		DEFAULT_SUBJECT_ENCODING,
		MAX_SUBJECT_LEVEL,
		getSubjectLevelCount,
		getSubjectSegmentLength,
		parseSubjectEncoding,
		stringifySubjectEncoding
	} from '@/utils/subjectEncoding';

	const emptyForm = {
		"code": "",
		"name": "",
		"mnemonicCode": "",
		"balanceDirection": "借",
		"auxiliaryAccounting": null,
		"currencyAccounting": null,
		"periodEndRevaluation": false,
		"status": true
	};

	export default {
		name: "Subject",
		data() {
			return {
				codeLen: parseSubjectEncoding(DEFAULT_SUBJECT_ENCODING),
				segmentLenOptions: [1, 2, 3, 4],
				maxSubjectLevel: MAX_SUBJECT_LEVEL,
				tabDatas: [{
					title: '资产',
					key: 'CodeAssets'
				}, {
					title: '负债',
					key: 'CodeLiabilities'
				}, {
					title: '权益',
					key: 'CodeInterest'
				}, {
					title: '成本',
					key: 'CodeCost'
				}, {
					title: '损益',
					key: 'CodeLoss'
				}],
				datas: [],
				accountingCategory: [],
				currencyOptions: [],
				auxiliaryAccounting: [],
				currencyAccounting: [],
				unit: '',
				validationRules: {
					required: ["code", "name"]
				},
				parent: null,
				len: 2,
				encodingSettingForm: false,
				numberAccounting: false,
				assistAccounting: false,
				enableCurrencyAccounting: false,
				form: HeyUtils.copy(emptyForm),
				showForm: false,
				used: false,
				type: "资产",
				selected: 'CodeAssets',
				loading: false,
				showImportMappingModal: false,
				importPreview: {},
				importMappingRows: [],
				importHeaderOptions: [],
				pendingImportFile: null,
				overwriteExistingOnImport: false
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			encodingPreview() {
				return stringifySubjectEncoding(this.codeLen);
			},
			parentSubject() {
				return this.parent ? this.parent.name : '';
			},
			showUnit() {
				return this.datas.find(value => !!value.unit)
			},
			showAssistAccounting() {
				return this.datas.find(value => !!value.auxiliaryAccounting)
			},
			showCurrencyAccounting() {
				return this.datas.find(value => !!value.currencyAccounting)
			},
			showPeriodEndRevaluation() {
				return this.datas.find(value => !!value.periodEndRevaluation)
			}
		},
		watch: {
			type() {
				this.loadList()
			},
			'currentAccountSets.encoding'() {
				this.syncCodeLenFromCurrentEncoding();
			},
			showForm(val) {
				if (!val) {
					this.parent = null;
					this.used = false;
					this.form = HeyUtils.copy(emptyForm);
					this.numberAccounting = false;
					this.assistAccounting = false;
					this.enableCurrencyAccounting = false;
					this.unit = '';
					this.auxiliaryAccounting = [];
					this.currencyAccounting = [];
				}
			},
			numberAccounting(val) {
				if (!val) {
					this.form.unit = '';
				}
			},
			enableCurrencyAccounting(val) {
				if (!val) {
					this.form.periodEndRevaluation = false;
				}
			}
		},
			methods: {
				goInitImportWizard() {
					this.$router.push({name: 'InitialImportCenter'});
				},
			encodingSetting() {
				this.syncCodeLenFromCurrentEncoding();
				this.encodingSettingForm = true;
			},
			syncCodeLenFromCurrentEncoding() {
				this.codeLen = parseSubjectEncoding((this.currentAccountSets && this.currentAccountSets.encoding) || DEFAULT_SUBJECT_ENCODING);
			},
			addEncodingLevel() {
				if (this.codeLen.length >= this.maxSubjectLevel) {
					this.$Message.error(`最多支持${this.maxSubjectLevel}级科目`);
					return;
				}
				this.codeLen.push(2);
			},
			removeEncodingLevel() {
				if (this.codeLen.length <= 1) {
					return;
				}
				this.codeLen.pop();
			},
			canCreateChild(data) {
				if (!data) {
					return true;
				}
				return Number(data.level || 0) < getSubjectLevelCount(this.codeLen);
			},
			repairLevels() {
				this.$Confirm("确定要根据科目编码规则自动修复所有科目的层级和父子关系吗？这通常能解决缩进错乱的问题。").then(() => {
					this.loading = true;
					this.$api.setting.subject.repairLevels().then(() => {
						this.$Message.success("修复成功");
						this.loadList();
					}).catch(() => {
						this.$Message.error("修复失败");
					}).finally(() => {
						this.loading = false;
					});
				});
			},
			saveEncoding() {
				let code = stringifySubjectEncoding(this.codeLen);
				if (code !== this.currentAccountSets.encoding) {
					this.loading = true;
					this.$api.setting.accountSets.updateEncode({encoding: this.currentAccountSets.encoding, newEncoding: code}).finally(() => {
						this.encodingSettingForm = false;
						this.loading = false;
					}).then(() => {
						this.loadList();
						this.$store.dispatch('init');
					});
				} else {
					this.encodingSettingForm = false;
				}
			},
			toPy() {
				let pyArr = [];
				this.form.name.split("").forEach(w => {
					w = w.trim();
					if (w) {
						if (/[\u4e00-\u9fa5]/.test(w)) {
							let py = Pinyin(w, {removeTone: true, keepRest: true}).trim();
							pyArr.push(py.substring(0, 1));
						} else {
							pyArr.push(w);
						}
					}
				});

				if (this.parent) {
					this.$set(this.form, 'mnemonicCode', this.parent.mnemonicCode + "_" + pyArr.join(""));
					if (!this.form.id) {
						this.$set(this.form, 'code', this.parent.code + this.form.code);
					}
				} else {
					this.$set(this.form, 'mnemonicCode', pyArr.join(""));
				}
			},
			loadList() {
				this.loading = true;
				this.$api.setting.subject.list(this.type).then(({data}) => {
					this.datas = data || [];
					this.loading = false
				});
			},
			loadAccountingCategory() {
				this.$api.setting.accountingCategory.list().then(({data}) => {
					this.accountingCategory = data;
				});
			},
			loadCurrencies() {
				this.$api.setting.currency.list().then(({data}) => {
					this.currencyOptions = (data || []).filter(item => !item.localCurrency).map(item => Object.assign({}, item, {
						displayName: `${item.code} ${item.name}`
					}));
				});
			},
			formatCurrencyAccounting(currencyAccounting) {
				if (!currencyAccounting) {
					return '';
				}
				try {
					const parsed = JSON.parse(currencyAccounting);
					if (Array.isArray(parsed)) {
						return parsed.map(val => val.code || val.name || val).join(',');
					}
				} catch (e) {
					return String(currencyAccounting).split(',').map(val => val.trim()).filter(Boolean).join(',');
				}
				return String(currencyAccounting).split(',').map(val => val.trim()).filter(Boolean).join(',');
			},
			parseCurrencyAccounting(currencyAccounting) {
				if (!currencyAccounting) {
					return [];
				}
				try {
					const parsed = JSON.parse(currencyAccounting);
					if (Array.isArray(parsed)) {
						return parsed.map(val => (val.code || val.name || val)).filter(Boolean);
					}
				} catch (e) {
					// noop
				}
				return String(currencyAccounting).split(',').map(val => val.trim()).filter(Boolean);
			},
			submit() {
				let validResult = this.$refs.form.valid();
				if (validResult.result) {
					this.toPy();
					this.loading = true;

					if (this.assistAccounting && this.auxiliaryAccounting.length) {
						this.form.auxiliaryAccounting = JSON.stringify(this.auxiliaryAccounting.map(value => {
							let act = this.accountingCategory.find(item => item.id == value);
							return {id: act.id, name: act.name};
						}));
					} else {
						this.form.auxiliaryAccounting = '';
					}

					if (this.numberAccounting && this.unit) {
						this.form.unit = this.unit;
					} else {
						this.form.unit = '';
					}

					if (this.enableCurrencyAccounting && this.currencyAccounting.length) {
						this.form.currencyAccounting = this.currencyAccounting.join(',');
					} else {
						this.form.currencyAccounting = '';
						this.form.periodEndRevaluation = false;
					}

					this.$api.setting.subject[this.form.id ? 'update' : 'save'](Object.assign(this.form)).then(() => {
						this.loadList();
						this.showForm = false;
						this.loading = false;
					}).catch(() => {
						this.loading = false;
					})
				}
			},
			create(data) {
				this.parent = data;
				if (!data) {
					data = {level: 0, type: this.type, balanceDirection: '借'};
				}
				this.showForm = true;
				let children = this.datas.filter(value => value.parentId == data.id);
				let len = getSubjectSegmentLength(this.codeLen, data.level + 1) || 2;
				this.len = len;
				let start = "1";
				if (children.length) {
					let code = children[children.length - 1].code;
					start = (parseInt(code.substr(code.length - len)) + 1) + "";
				}
				this.form.code = StringUtils.pad(start, 0 - (len - start.length), "0");
				this.form.type = data.type;
				this.form.parentId = data.id;
				this.form.level = data.level + 1;
				this.form.balanceDirection = data.balanceDirection;
			},
			change(data) {
				this.type = data.title;
			},
			remove(data) {
				this.$Confirm("确认删除?").then(() => {
					this.$api.setting.subject.delete(data.id).then(() => {
						this.loadList();
					})
				})
			},
			edit(row) {
				Api.setting.subject.checkUse(row.id).then(({data}) => {
					this.used = data;
					this.parent = this.datas.find(value => value.id == row.parentId);
					this.numberAccounting = !!row.unit;
					this.assistAccounting = !!row.auxiliaryAccounting;
					this.enableCurrencyAccounting = !!row.currencyAccounting;
					this.unit = row.unit;
					this.auxiliaryAccounting = [];
					this.currencyAccounting = [];
					if (row.auxiliaryAccounting) {
						this.auxiliaryAccounting = JSON.parse(row.auxiliaryAccounting).map(val => val.id);
					}
					if (row.currencyAccounting) {
						this.currencyAccounting = this.parseCurrencyAccounting(row.currencyAccounting);
					}
					this.form = Object.assign({}, row);
					this.form.periodEndRevaluation = !!row.periodEndRevaluation;
					this.showForm = true;
				});
			},
			doUpload() {
				this.$refs.file.click();
			},
			exportSubjects() {
				this.$api.setting.subject.exportData().then(() => {
					this.$Message("科目导出成功");
				}).catch(() => {
					this.$Message.error("科目导出失败");
				});
			},
			downloadTemplate() {
				this.$api.setting.subject.downloadTemplate().then(() => {
					this.$Message("模板下载成功");
				}).catch(() => {
					this.$Message.error("模板下载失败");
				});
			},
			fileChange() {
				if (!this.$refs.file.files.length) return;
				let file = this.$refs.file.files[0];
				this.$refs.file.value = "";
				this.pendingImportFile = file;
				let formData = new FormData();
				formData.append('file', file);
				this.loading = true;
				this.$api.setting.subject.previewImport(formData).then(({data}) => {
					this.importPreview = data || {};
					let mappings = (data && data.mappings) || [];
					this.importMappingRows = mappings.map(item => Object.assign({}, item, {
						actual: item.actual || ''
					}));
					this.importHeaderOptions = [''].concat((data && data.sourceHeaders) || []);
					if (data && data.needConfirm) {
						this.showImportMappingModal = true;
					} else {
						let mapping = {};
						this.importMappingRows.forEach(item => {
							if (item.actual) {
								mapping[item.expected] = item.actual;
							}
						});
						this.executeImport(mapping, data ? data.headerRowIndex : null);
					}
				}).catch((error) => {
					this.$Message.error("导入预检失败: " + (error.message || "未知错误"));
					this.pendingImportFile = null;
				}).finally(() => {
					this.loading = false;
				});
			},
			formatConfidence(value) {
				if (!value && value !== 0) return '-';
				return `${Math.round(Number(value) * 100)}%`;
			},
			cancelImportMapping() {
				this.showImportMappingModal = false;
				this.importPreview = {};
				this.importMappingRows = [];
				this.importHeaderOptions = [];
				this.pendingImportFile = null;
			},
			confirmImportMapping() {
				let duplicateCheck = new Set();
				let mapping = {};
				for (let i = 0; i < this.importMappingRows.length; i++) {
					let item = this.importMappingRows[i];
					let selected = item.actual || '';
					if (selected) {
						if (duplicateCheck.has(selected)) {
							this.$Message.error(`导入列[${selected}]重复选择，请重新确认`);
							return;
						}
						duplicateCheck.add(selected);
						mapping[item.expected] = selected;
					}
					if (item.required && !selected) {
						this.$Message.error(`必填字段[${item.expected}]未映射，请先选择`);
						return;
					}
				}
				this.showImportMappingModal = false;
				this.executeImport(mapping, this.importPreview ? this.importPreview.headerRowIndex : null);
			},
			executeImport(mapping = {}, headerRowIndex) {
				if (!this.pendingImportFile) {
					this.$Message.error("未找到待导入文件，请重新选择");
					return;
				}
				let formData = new FormData();
				formData.append('file', this.pendingImportFile);
				formData.append('overwriteExisting', this.overwriteExistingOnImport ? 'true' : 'false');
				if (mapping && Object.keys(mapping).length) {
					formData.append('headerMapping', JSON.stringify(mapping));
				}
				if (headerRowIndex !== null && headerRowIndex !== undefined) {
					formData.append('headerRowIndex', headerRowIndex);
				}
				this.loading = true;
				this.$api.setting.subject.import(formData).then(() => {
					this.$Message("亲,导入成功~");
					this.loadList();
				}).catch((error) => {
					if (error && error.msg) {
						return;
					}
					this.$Message.error("导入失败: " + ((error && error.message) || "未知错误"));
				}).finally(() => {
					this.loading = false;
					this.pendingImportFile = null;
					this.importPreview = {};
					this.importMappingRows = [];
					this.importHeaderOptions = [];
				});
			}
		},
		mounted() {
			this.syncCodeLenFromCurrentEncoding();
			if (this.currentAccountSets.accountingStandards !== 0) {
				this.tabDatas = [{
					title: '资产',
					key: 'CodeAssets'
				}, {
					title: '负债',
					key: 'CodeLiabilities'
				}, {
					title: '共同',
					key: 'Common'
				}, {
					title: '权益',
					key: 'CodeInterest'
				}, {
					title: '成本',
					key: 'CodeCost'
				}, {
					title: '损益',
					key: 'CodeLoss'
				}];
			}
			this.loadList();
			this.loadAccountingCategory();
			this.loadCurrencies();
		}
	};
</script>

<style scoped>
	div.h-tabs.h-tabs-card {
		border-bottom: 1px solid #52abc50d;
	}

	div.h-panel-body {
		padding-top: 0px;
	}

	div.h-panel-bar {
		border-bottom: 0px solid #eeeeee;
		border-top: 1px solid #eeeeee;
	}

	.used {
		position: absolute;
		right: 50px;
		z-index: 10;
		top: 0;
	}

	.encoding-setting-item {
		display: flex;
		align-items: center;
		margin-bottom: 12px;
	}

	.encoding-setting-label {
		display: inline-block;
		width: 80px;
	}

	.encoding-fixed {
		display: inline-block;
		width: 120px;
		line-height: 32px;
	}

	.encoding-setting-actions {
		display: flex;
		align-items: center;
		gap: 10px;
		flex-wrap: wrap;
	}
</style>
